import { render, staticRenderFns } from "./LensesCombinationViz.vue?vue&type=template&id=0780f0f6&scoped=true"
import script from "./LensesCombinationViz.vue?vue&type=script&lang=js"
export * from "./LensesCombinationViz.vue?vue&type=script&lang=js"
import style0 from "./LensesCombinationViz.vue?vue&type=style&index=0&id=0780f0f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780f0f6",
  null
  
)

export default component.exports